import React from 'react'
import { PromtsBoardContent } from './PromtsBoardContent'
import PromptsModalProvider from './PromtsModalProvider'

const PromtsBoard = () => {
  return (
    <PromptsModalProvider>
      <PromtsBoardContent />
    </PromptsModalProvider>
  )
}

export default PromtsBoard
